export default __webpack_public_path__ + "static/media/page-title-cases-en.318082cb.svg";